module.exports = require("extend");


//////////////////
// WEBPACK FOOTER
// external "extend"
// module id = 50
// module chunks = 0